/*
 * Seeds
 *
 * Use this file to populate an empty Firestore or reset the content
 * of the Firestore.
 */



const seeds = {
    en: {
        'banner': 'Share your ideas and experiences to build the future of the University of New Mexico',
        'title': 'University of New Mexico Integrated Campus Plan',

        'animation.icon1': 'Eat',
        'animation.icon2': 'Gather',
        'animation.icon3': 'Walk',
        'animation.icon4': 'Transit',
        'animation.icon5': 'Live',
        'animation.prompt1': 'Where do you ...',
        'animation.prompt2': 'How do you get around ...',

        'engagement.title': 'Engagement Survey',
        'engagement.button': 'Share Your Ideas',

        'Welcome.title': "Let's envision the future of UNM campus together.",
        'Welcome.body': "Share your ideas and experiences to build the future of the University of New Mexico",

        'Vision.title': "The Future of UNM",
        'Vision.subtitle': "Vision & About",
        'Vision.body': "<p>The University of New Mexico has commenced its Integrated Campus Plan process and retained Sasaki Associates to lead a multidisciplinary team to assist with the development of the plan. The Integrated Campus Plan process is grounded in the University’s Strategic Plan <a href='' rel='noopener noreferrer' target='_blank'>UNM 2040: Opportunity Defined</a> and other previous planning efforts and will assist the University in physically translating its academic mission and strategic vision. The Integrated Campus Plan will focus on the facilities, grounds, and physical assets of the institution to provide a “road map” to fulfill the vision.</p>",
        'Vision.historical.title': 'In the foreground sits Hodgin Hall, the first building built at UNM',
        'Vision.historical.image': '',
        'Vision.present.title': 'Recently updated Smith Plaza in front of Zimmerman Library',
        'Vision.present.image': '',

        'Process.title': "The planning process",
        'Process.subtitle': "Process & Timeline",
        'Process.body': 'This is a new paragraph section.',

        'Process.items': [
            
            {
                'name': 'Phase 01',
                'duration': "September 2022 - December 2022",
                'title': 'Discovery and Analysis',
                'body': 'During the first phase, the Sasaki team will gather and integrate past campus plans and studies and conduct a thorough site visit to understand current conditions and key objectives for the Integrated Campus Plan. Key phase one developments will include a series of meetings with the core UNM planning team (core team) and facilities management, collaborative defining of guiding principles, and stakeholder interviews with members of the UNM community from executive leadership to regents, administrators, faculty, staff, students, and community partners.',
            },
            {
                'name': 'Phase 02',
                'duration': 'January 2023 - July 2023',
                'title': 'Development and Drafting of the Plan',
                'body': 'During the first phase, the Sasaki team will gather and integrate past campus plans and studies and conduct a thorough site visit to understand current conditions and key objectives for the Integrated Campus Plan. Key phase one developments will include a series of meetings with the core UNM planning team (core team) and facilities management, collaborative defining of guiding principles, and stakeholder interviews with members of the UNM community from executive leadership to regents, administrators, faculty, staff, students, and community partners.',
            },
            {
                'name': 'Phase 03',
                'duration': 'August 2023 - November 2023',
                'title': 'Implementation',
                'body': 'Based on the input our team gathered throughout Phase 2, we will develop a preferred plan. This will illustrate key ideas and recommendations of the selected plan and its supporting strategies in greater detail. The planning team will also identify priority projects to help the University develop an approach to phasing and implementation of future projects. The draft ICP plan will be reviewed by UNM’s core team and any public review the University deems necessary.',
            },
            {
                'duration': "September '22 - November '23",
                'title': 'On-Going Engagement',
                'body': 'You are at the heart of this story. At every point in the project, we will reach out to you and others across UNM’s many communities to ask for your insight, reactions, and feedback both virtually and in-person. This website will always have the latest news on how you can share your voice! Sign up to get updates.[link to sign up form at the bottom of the page]',
            }
        ],

        'Resources.title': "Project resources",
        'Resources.subtitle': "Resources & Updates",
        'Resources.body': "",

        'resources': [
            {
                'title': 'UNM 2040',
                'subtitle': 'Link to Website',
                'action': 'link',
                'image': '',
            }
        ],

        'Contact.title': "Get involved today",
        'Contact.subtitle': "Contact & Share Your Ideas",
        'Contact.prompt.name': 'Hi, my name is',
        'Contact.prompt.role': "and I'm a",
        'Contact.prompt.email': "and my email address is",
        'Contact.prompt.message': "my message",
        'Contact.submit': "Send",
        'Contact.thanks': "Thanks!",
        'Contact.error': 'Ooops! There was an error.',

        'privacy': "We respect your privacy and do not share your information with anyone.",
    }
};

export default seeds;
